export default "__VITE_ASSET__SESQXp7C__"